import React, {useEffect, useRef, useState, useCallback} from 'react';
import styles from './Telephone.module.scss'
import panelStyles from "components/homePanels/Panels.module.scss";
import parallaxStyles from 'components/homeParallax/HomeParallax.module.scss';
import {buttonClick, forceRedraw/*, scrollToElement*/} from "utils/Helpers";
import ArrowRight from "components/icons/arrowRight/ArrowRight";
import {gsap} from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollEvent from "utils/ScrollEvent";
// import TelephoneVideo from "components/homePanels/j_telephone/telephoneVideo/TelephoneVideo";
import PortraitVideo from "components/homePanels/k_telephone/portraitVideo/PortraitVideo";
import NavToggle from "components/icons/navToggle/NavToggle";
import MouseMove from "utils/MouseMove";
import PanelAnimations from "utils/PanelAnimations";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import mainStyles from "components/homeParallax/HomeParallax.module.scss";
import {useDispatch, useSelector} from "react-redux";
import HeaderLogo from "components/headerLogo/HeaderLogo";
import GrabToScroll from "utils/GrabToScroll";
import {chapters, introText} from "./Telephone.data";
import Tilt from "utils/Tilt";
import SwipeIcon from "components/icons/swipeIcon/SwipeIcon";
gsap.registerPlugin(ScrollTrigger);

const Telephone = (props) => {

    const accessible = useSelector(state => state.accessible);
    const windowData = useSelector(state => state.window);
    const dispatch = useDispatch()
    const hero = useRef();
    const button = useRef();
    const foreGround = useRef();
    const bonusGround = useRef();
    const midGround = useRef();
    const backGround = useRef();
    const fixedStage = useRef();
    // const content = useRef();
    const sideArrow = useRef();
    const isAnimating = useRef();
    const finalFocus = useRef();
    const lastFocus = useRef();
    const [finalDisplay, setFinalDisplay] = useState(null);
    const finalVideo = useRef();

    const scrollPos = useRef(0)

    const loadBg = useCallback((node,key)=>{

        let chapter = chapters.find((chapter)=> chapter.key === key);
        let slideCount = chapter.slides.length

        let bgWidth = slideCount * 100;
        if(windowData.width >= 768) bgWidth = slideCount * 50;

        let finalSlide,
            vidSlides,
            textSlides,
            comeBackSlide;

        if(windowData.width >= 1024) {
            finalSlide = chapter.final ? 50 : 0;
            vidSlides = chapter.slides.filter((slide) => !slide.text);
            textSlides  = chapter.slides.filter((slide) => slide.text);
            comeBackSlide  = chapter.slides && !chapter.final ? 33.33 : 0;
            bgWidth = finalSlide + comeBackSlide + (vidSlides.length * 33.33) + (textSlides.length * 33.33)
        }

        if(windowData.width >= 1440){
            finalSlide = chapter.final ? 33.33 : 0;
            bgWidth = finalSlide + comeBackSlide + (vidSlides.length * 33.33) + (textSlides.length * 16.66)
        }

        let spacer = 100;
        if(windowData.width >= 1024) {spacer = 33.3}
        if(windowData.width >= 1440) {spacer = 0}

        if(node) node.style.width = bgWidth + spacer + 'vw';

    }, [windowData.width])


    useEffect(()=>{
        fixedStage.current.scrollLeft = 0;
    },[accessible.exploring])

    /** firefox remembers scroll position, reset on the way out the door **/
    window.addEventListener('beforeunload', ()=>{
        fixedStage.current.scrollLeft = 0
    })

    /** on load screen reader focus on main image **/
    useEffect(()=>{
        if(props.status === 'active' && accessible.siteEntered) {
            setTimeout(()=>{
                if(foreGround.current) foreGround.current.firstChild.focus();
            }, 1000)

        }
    }, [props.status, accessible.siteEntered])

    useEffect(()=>{

        if(accessible.exploring && props.status === 'active'){
            isAnimating.current = true;

            gsap.to(button.current, {duration: 0.6, scale: 0, opacity: 0, onComplete: ()=>{
                    gsap.to(sideArrow.current, {delay: 0, duration: 0.6, width: '180px'})
                }})

            setTimeout(()=>{
                fixedStage.current.classList.remove(parallaxStyles.snapType)
                scrollPos.current = window.innerWidth;
                gsap.to(fixedStage.current, {duration: 1.5, scrollTo: {x: window.innerWidth}, onComplete: ()=>{
                        resetSnap(true);
                        isAnimating.current = false;
                    }
                });
            }, 1000)

        } else if(!accessible.exploring && props.status === 'active') {
            if(sideArrow.current){
                gsap.to(button.current, {duration: 0, scale: 1, opacity: 1})
                gsap.to(sideArrow.current, {duration: 0, width: 0})

            }
        }


    }, [accessible.exploring, props.status]);

    const horizontalGrabCheck = useCallback(()=>{
        setTimeout(()=>{

            let isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;

            if(fixedStage.current.scrollLeft < 50 && !isFullScreen){
                dispatch({ type: "SET_ACCESSIBLE",
                    payload: {
                        ...accessible,
                        exploring: false,
                        topExit: true
                    }
                });

            }
        }, 1000)

    },[accessible, dispatch])

    function horizontalCheck(){

        let isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;

        if(accessible.exploring && props.status === 'active' && fixedStage.current.scrollLeft < 50 && !isFullScreen){
            dispatch({ type: "SET_ACCESSIBLE",
                payload: {
                    ...accessible,
                    exploring: false,
                    topExit: true
                }
            });
        }

    }

    function scrollReset(){

        let isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;

        if(!isFullScreen){
            resetSnap()
            horizontalGrabCheck()
        }

    }

    function resetSnap(){

        /** hack to force snap styles to activate **/
        fixedStage.current.classList.add(parallaxStyles.snapType)
        /** hack without going at least 1 further, it snaps back to the landing **/
        fixedStage.current.scrollLeft = scrollPos.current+1;
        forceRedraw();
        fixedStage.current.scrollLeft = scrollPos.current;

    }

    function exploreTelephone(){
        fixedStage.current.classList.remove(parallaxStyles.snapType);
        forceRedraw();
        dispatch({ type: "SET_ACCESSIBLE",
            payload: {
                ...accessible,
                exploring: true
            }
        });
    }

    function buildSlides(){

        let slides = [];

        chapters.forEach((chapter, chapterIndex)=>{

            /** intro slide **/
            let bg = chapter.intro.soon ? chapter.intro.soonBackground : chapter.intro.background
            slides.push(
                <div key={`intro_${chapterIndex}`} className={`${styles.slide} ${styles.snap} ${styles.intro} ${styles[`${chapter.key}Intro`]}`} style={{backgroundImage: `url(${bg})`}}>
                    <div className={styles.macroIntro}>
                        <p>{chapter.intro.kicker}</p>
                        <h4>{chapter.intro.title}</h4>
                        {chapter.intro.soon && <div className={styles.soon}>{chapter.intro.soon}</div>}
                    </div>
                </div>
            )

            if(chapter.slides){

                /** diary slides **/
                chapter.slides.forEach((slide, slideIndex)=>{

                    if(slide.text){
                        slides.push(
                            <div key={`${chapter.key}_slide_${slideIndex}`} className={`${styles.slide} ${styles.slideText}`}>
                                <p>{slide.text}</p>
                            </div>
                        )
                    }

                    if(slide.snap){
                        slides.push(
                            <div key={`${chapter.key}_slide_${slideIndex}`} className={`${styles.slide} ${styles.snap}`}>
                                {slideIndex === 0 && <div aria-hidden={true} ref={(node)=>loadBg(node,chapter.key)} className={styles.wideBg} style={{backgroundImage: `url(${chapter.wideBg})`}}/>}
                                <div className={styles.slideInfo}>
                                    <p>{slide.snap.kicker}</p>
                                    <h4>{slide.snap.title}</h4>
                                </div>
                                <PortraitVideo src={slide.snap.video} poster={slide.snap.poster} cc={slide.snap.cc}/>
                            </div>
                        )
                    }

                })

            }

            if(chapter.slides && !chapter.final){

                slides.push(
                    <div key={`${chapter.key}_comeBack_${chapterIndex}`} className={`${styles.slide} ${styles.snap} ${styles.comeBack}`}>
                        {chapter.slides.length === 0 && <div aria-hidden={true} ref={(node)=>loadBg(node,chapter.key)} className={styles.wideBg} style={{backgroundImage: `url(${chapter.wideBg})`}}/>}
                        <div className={styles.slideInfo}>
                            <div>{chapter.comeBack}</div>
                        </div>
                    </div>
                )
            }


            /** final slide **/

            if(chapter.final){
                slides.push(
                    <div key={`${chapter.key}_final_${chapterIndex}`} className={`${styles.slide} ${styles.snap} ${styles.finalSlide}`}>
                        <div tabIndex={-1} className={styles.slideInfo}>
                            <p>{chapter.final.kicker}</p>
                            <h4>{chapter.final.title}</h4>
                        </div>
                        <div className={styles.finalLink} aria-hidden={accessible.modalOpen} tabIndex={0} role={'button'} aria-label={'Final Piece'}  onKeyDown={buttonClick} onClick={(e)=>toggleFinalDisplay(e,chapter)}>
                            {chapter.final.video && (
                                <span>
                                    <ImageWrapper className={styles.play} set={{default: 'https://msobd-storage.azureedge.net/images/play.png'}} alt={''}/>
                                </span>
                            )}
                            <ImageWrapper set={{default: chapter.final.thumb}} alt={`${chapter.intro.title} Final`}/>
                        </div>
                    </div>
                )
            }


        })

        return slides;
    }

    function toggleFinalDisplay(e, chapter){
        if(chapter) lastFocus.current = e.currentTarget.parentNode.parentNode.firstChild
        if(!chapter && finalVideo.current){
            finalVideo.current.pause();
        }
        setTimeout(()=>setFinalDisplay(chapter), 100)

    }

    useEffect(()=>{

        if(finalDisplay && finalFocus.current) finalFocus.current.focus();
        if(!finalDisplay && lastFocus.current) lastFocus.current.focus(); //Text wont get blue focus ring

        if(accessible.telephoneModal !== !!finalDisplay){

            dispatch({ type: "SET_ACCESSIBLE",
                payload: {
                    ...accessible,
                    telephoneModal: !!finalDisplay
                }
            });

        }


    }, [finalDisplay, accessible, dispatch])

    function isVideoPlaying(play){
        dispatch({ type: "SET_ACCESSIBLE",
            payload: {
                ...accessible,
                videoActive: play
            }
        });
    }

    function buildFinalDisplay(){

        if(finalDisplay){

            let display = finalDisplay.final.image ? (
                <ImageWrapper tabIndex={-1} ref={finalFocus} set={{default: finalDisplay.final.image}} alt={`${finalDisplay.intro.title} final product`}/>
            ) : (
                <video ref={finalVideo} aria-hidden={true} autoPlay playsInline controls={true} loop autobuffer={'true'}
                       onPause={()=>isVideoPlaying(false)} onPlay={()=>isVideoPlaying(true)}>
                    <source src={finalDisplay.final.video} type="video/mp4"/>
                </video>
            )

            return (
                <div className={styles.finalDisplay}>
                    {display}
                    <div tabIndex={0} role={'button'} aria-label={'Close modal'} className={styles.close} onKeyDown={buttonClick} onClick={(e)=>toggleFinalDisplay(e,null)}><NavToggle menuOpen={true} closeOnly={true} color={'#fff'}/></div>
                </div>
            )
        }
    }

    function getContent(){

        if(accessible.exploring){
            return (
                <>

                    {/*<div ref={content} className={`${styles.fullSlide} ${styles.snap}`}>*/}
                    {/*    <TelephoneVideo/>*/}
                    {/*</div>*/}

                    <div className={`${styles.slide} ${styles.snap} ${styles.slide1}`}>
                        <h4>{introText.title}</h4>
                        <div dangerouslySetInnerHTML={{__html:introText.content}}/>
                    </div>

                    {/********************* BROOKE *********************/}

                    {buildSlides()}


                    <ScrollEvent target={fixedStage.current} scroll={horizontalCheck} debounce={100} mobileCheck={true}/>
                    <GrabToScroll stage={fixedStage} scrollReset={scrollReset} scrollPos={scrollPos}/>

                </>
            )
        }

    }

    return (
        <>
            <div ref={fixedStage} data-status={props.status} className={`telephoneStage ${panelStyles.fixedStage} ${panelStyles.row} ${styles.sideSwipe} ${accessible.exploring ? styles.locked : ''}`} style={{zIndex: props.zIndex}}>

                {accessible.exploring && <HeaderLogo menuClick={()=>props.menuClick('introText')}/>}

                {accessible.exploring && <SwipeIcon/>}

                <div ref={hero} className={`${panelStyles.hero} ${styles.fullSlide} ${styles.snap}`}>
                    <div ref={foreGround}  className={`${panelStyles.foreGround}`}>
                        <ImageWrapper tabIndex={-1} className={panelStyles.logo} set={{default:`https://msobd-storage.azureedge.net/images/telephone/ProjectInspire_4Squares_Phase4.png`}} alt={''}/>
                        <div className={`${panelStyles.info} ${styles.info}`}>
                            <h3>Project Inspire</h3>

                            <span tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={'Follow the journey'} onKeyDown={buttonClick}
                                  ref={button} className={`explore ${panelStyles.explore} ${panelStyles.button} ${panelStyles.white}`} onClick={()=>exploreTelephone()}>
                                <span className={`${panelStyles.ctaText}`} dangerouslySetInnerHTML={{__html:'Follow the journey'}}/><span className={panelStyles.carat}>&rsaquo;&rsaquo;</span>
                            </span>
                        </div>

                        <div ref={sideArrow} className={styles.sideArrow}>
                            <ArrowRight fill={'#fff'}/>
                        </div>
                    </div>

                </div>

                <div aria-hidden={true} ref={bonusGround} className={`${panelStyles.bonusGround} ${accessible.exploring ? styles.overflow : ''}`}>
                    <ImageWrapper className={styles.bonusGround} set={{default:`https://msobd-storage.azureedge.net/images/telephone/tele-midground.png`}} alt={''}/>
                </div>

                <div aria-hidden={true} ref={midGround} className={`${panelStyles.midGround} ${accessible.exploring ? styles.overflow : ''}`}>
                    <ImageWrapper className={styles.midGround} set={{default:`https://msobd-storage.azureedge.net/images/telephone/tele-foreground.png`}} alt={''}/>
                </div>

                <div aria-hidden={true} ref={backGround} className={`${panelStyles.backGround} ${accessible.exploring ? styles.overflow : ''}`}>
                    <ImageWrapper className={styles.backGround} set={{default:`https://msobd-storage.azureedge.net/images/telephone/tele-background.gif`}} alt={''}/>
                </div>

                {getContent()}



                <span className={mainStyles.accessibleContent} tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={'Navigate to next section'} onKeyDown={buttonClick} onClick={props.nextPanel}/>
                <span className={mainStyles.accessibleContent} tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={'Navigate to previous section'} onKeyDown={buttonClick} onClick={props.prevPanel}/>

                <PanelAnimations fixedStage={fixedStage} backGround={backGround} foreGround={foreGround} midGround={midGround} bonusGround={bonusGround} panel={'project-inspire'}/>

                <MouseMove status={props.status} backGround={backGround} midGround={midGround} bonusGround={bonusGround} />

                <Tilt backGround={backGround}  midGround={midGround} bonusGround={bonusGround}/>

            </div>

            {buildFinalDisplay()}

        </>
    )
};

export default Telephone
